export class ImageViewport {
  static readonly W10H1 = 'w10h1'
  static readonly W8H1 = 'w8h1'
  static readonly W6H1 = 'w6h1'
  static readonly W4H1 = 'w4h1'
  static readonly W3H1 = 'w3h1'
  static readonly W2H1 = 'w2h1'
  static readonly W1H1 = 'w1h1'
}
